module.exports = __webpack_public_path__ + "img/logo-horizontal.c55f9edf.png";